import { Card } from 'antd';
import { AttachmentList } from '@/components/attachments/AttachmentList';
import { ATTACHMENT_COPY } from '@/components/attachments/copy';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C2b §3, split C3a §3] THE FILES PINNED TO AN ORDER — THE DETAIL PAGE'S FRAME.
 *
 *  Everything that decides what an attachment ROW is moved to
 *  `components/attachments/AttachmentList.tsx`, because §3 puts the same control on the
 *  arrangement BUILDER's first step and a second copy is a second definition. What is left here
 *  is the FRAME: a titled card in the identity column, which is this page's own choice and not
 *  the builder's.
 *
 *  ⚠️ THE TESTIDS ARE UNCHANGED — `attachments-card`, `attach-file`, `attachment-row`. A move
 *  that renames a handle is a move that breaks a spec for a reason unrelated to what it asserts.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const Attachments = ({
  arrangementId,
  canWrite,
}: {
  arrangementId: string;
  canWrite: boolean;
}): React.ReactElement => (
  <Card size="small" title={ATTACHMENT_COPY.title} data-testid="attachments-card">
    <AttachmentList arrangementId={arrangementId} canWrite={canWrite} />
  </Card>
);
